exports = module.exports = require("../../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1zRHneqHJ6_zMj8G8A8Qq4{\n    padding: 5px 2px;\n    display: inline-block;\n}", ""]);

// exports
exports.locals = {
	"toolbarItem": "_1zRHneqHJ6_zMj8G8A8Qq4"
};